/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// Test
require('./bootstrap');

window.Vue = require('vue');

// Componentes de VUE
Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('entrega-soporte', require('./components/EntregaSoporte.vue').default);

const app = new Vue ({
  el: '#app',
});

var dt = require( 'datatables.net' );
require('datatables.net-buttons');

// Global
var token = document.head.querySelector('meta[name="csrf-token"]');
var timercito;

// Funciones

/**
 * crearMensaje (tomado de Mi Unidad) xD
 */
window.crearMensaje = function (error,titulo,mensaje,tiempo=5000){
  var clase_mensaje = error==true?"alert-danger":"alert-success";
  var mensaje_alert = '<div class="alertaActivacion fb-error msj_js">';
  mensaje_alert += '<strong id="mensaje_negritas" style="font-size:16px;">'+titulo+'</strong>';
  mensaje_alert += '<p id="mensaje" style="font-size:14px;">'+mensaje+'</p>';
  mensaje_alert += '</div>';
  $("body").append(mensaje_alert);
  $(".msj_js").show();
  setTimeout(function(){
    $(".msj_js").remove();
  }, tiempo);
}

/**
 * alternar el formulario de tramite de alta
 */
function toggleForm1(){
  tpPersona=document.querySelector('input[name="tp-persona"]:checked').value;
  console.log(tpPersona);
  if(tpPersona=='moral'){
    $('#txRfc').prop('readonly', false);
    $('.toggle-group').hide('slow');
    $('.toggle-group-d').show('slow');
    $('#txCurp').attr('disabled', true);
    $('#txApellidoPat').attr('disabled', true);
    $('#txApellidoMat').attr('disabled', true);
    $('#tpPersona').val(2);
    $('#lbl-rfc').text('Ingresa el RFC de la empresa *');
    $('#lbl-nombre').text('Ingresa la razón social *');
    $('#lbl-identificacion-of').text('Identificación oficial del representante legal *');
    $('#biActaConst').attr('disabled', false);
    $('#id_cat_acta_const').attr('disabled', false);
    $('#biConstFis').attr('disabled', false);
    $('#id_cat_const_fis').attr('disabled', false);
    $('#fhConstitucion').attr('disabled', false);
    $('#biPoderNot').attr('disabled', false);
    $('#id_cat_pod_nota').attr('disabled', false);
    $('#fhOtorgamiento').attr('disabled', false);
    $('.pregunta-domicilio').addClass('d-none');
    $('#stMismoDomicilio').attr('disabled', true);
    $('#biCompDomicilio').attr('disabled', false);
    $('#txNombre').attr('readonly', false);
    if(document.getElementById('id_cat_identificacion').value==1){
      $('#txCurpRep').attr('disabled', false);
      $('#curpRepContainer').removeClass('d-none');
      console.log('mostro container pmor id = 1');
    }else{
      $('#txCurpRep').attr('disabled', true);
      $('#curpRepContainer').addClass('d-none');
      console.log('oculto container pmor id not 1');
    }
  }else{
    $('#txRfc').prop('readonly', true);
    $('.toggle-group').show('slow');
    $('.toggle-group-d').hide('slow');
    $('#txCurp').attr('disabled', false);
    $('#txApellidoPat').attr('disabled', false);
    $('#txApellidoMat').attr('disabled', false);
    $('#tpPersona').val(1);
    $('#lbl-rfc').text('Ingresa tu RFC *');
    $('#lbl-nombre').text('Ingresa tu nombre *');
    $('#lbl-identificacion-of').text('Identificación oficial del propietario *');
    $('#biActaConst').attr('disabled', true);
    $('#id_cat_acta_const').attr('disabled', true);
    $('#biConstFis').attr('disabled', true);
    $('#id_cat_const_fis').attr('disabled', true);
    $('#fhConstitucion').attr('disabled', true);
    $('#biPoderNot').attr('disabled', true);
    $('#id_cat_pod_nota').attr('disabled', true);
    $('#fhOtorgamiento').attr('disabled', true);
    $('#txNombre').attr('readonly', true);
    $('#txCurpRep').attr('disabled', true);
    $('#curpRepContainer').addClass('d-none');
    console.log('oculto container pfis');
    if(document.getElementById('id_cat_identificacion').value==1){
      $('.pregunta-domicilio').removeClass('d-none');
      $('#stMismoDomicilio').attr('disabled', false);
      $('#biCompDomicilio').attr('disabled', false);
    }else{
      $('.pregunta-domicilio').addClass('d-none');
      $('#stMismoDomicilio').attr('disabled', true);
      $('#biCompDomicilio').attr('disabled', true);
    }
  }
}

/**
 * Mostrar u ocultar campos de vendedor (vatos vehículo)
 */
function mismoNombreData(){
  mismo=document.querySelector('input[name="st-mismo-nombre"]:checked').value;
  if(mismo=='si'){
    $('.toggle-group').hide('slow');
    $('#biCompraVenta').attr('disabled', true);
    $('#id_cat_compraventa').attr('disabled', true);
    $('#biVendedor').attr('disabled', true);
    $('#id_cat_compraventa2').attr('disabled', true);
    $('#stMismoNombre').val('S');
  }else{
    $('.toggle-group').show('slow');
    $('#biCompraVenta').attr('disabled', false);
    $('#id_cat_compraventa').attr('disabled', false);
    $('#biVendedor').attr('disabled', false);
    $('#id_cat_compraventa2').attr('disabled', false);
    $('#stMismoNombre').val('N');
  }
}

/**
 * Cambiar nombre del trmite en Alta discapacidad
 */
$('.radio-resp-discapacidad').on('click', function(e){
  oName = 'input[name="'+$(this).attr('name')+'"]:checked';
  va = $(oName).val();
  if(va=='si'){
    $('#t-desc-larga').text($('#t-desc-larga').attr('u'));
    $('#tramite-url').attr('href',$('#tramite-url').attr('u'));
  }else if (va=='no'){
    $('#t-desc-larga').text($('#t-desc-larga').attr('n'));
    $('#tramite-url').attr('href',$('#tramite-url').attr('n'));
  }
  
});

/***
 * Estar validando la sesión
 */
function laSesion(){
  $.ajax({
    url: ubase+'/service/session/getSession',
    dataType: 'json',
    type: 'GET',
    success: function(data) {
        //
    },
    error: function(jqXHR, textStatus, errorThrown) {
      if(jqXHR.status === 401){
        crearMensaje(true,"Error","Tu sesión ha caducado");
        $('#modal-logo').modal({
          backdrop: 'static',
          keyboard: false
        });
        clearInterval(timercito);
      }
      if(jqXHR.status === 418){
        //crearMensaje(true,"Error",data.mensaje||data.message);
      }
    }
  });
}

/**
 * Tokencin
 */
$.ajaxSetup({
  headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});


/**
 * Controles de los archivos desde expediente
 */
window.removeFile = function (idControl){
  $('#'+idControl).val('');
  $('#isFromExp-'+idControl).val('');
  $('#controls-' + idControl).addClass('d-none');
  $('#filename-' + idControl ).html('');
}

/**
 * Descarga de archivos Blob
 * 
 */
window.b64toBlob = (b64Data, contentType='', sliceSize=512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}


/**
 * Google Maps
 */
function initMap(){
  if($('#map').length > 0){
    var list_modulos=[];
    var modulos = [];
    var icon = ubase + '/images/marcador.svg';
    $.ajax({
      url: ubase + "/service/semovi/get-modules",
      dataType: 'json',
      type: "GET",
      async: false,
      success: function(datasss) {
        list_modulos = datasss.modulos;
        for(m=0;m<list_modulos.length;m++) {
          modulos.push([
            list_modulos[m].nb_modulo, list_modulos[m].nu_latitud, list_modulos[m].nu_longitud
          ]);
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        crearMensaje(true,"Error","No pudimos procesar la solicitud<br>Código de error: " + jqXHR.status + " " + textStatus);
      }
    });


    window.map = new google.maps.Map(document.getElementById('map'), {      
      mapTypeId: 'roadmap',
      mapTypeControl: true,
      mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_CENTER
      },
      zoomControl: true,
      zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_CENTER
      },
      scaleControl: true,
      streetViewControl: false,
      fullscreenControl: false
    });

    var infowindow = new google.maps.InfoWindow();
    var bounds = new google.maps.LatLngBounds();
    for (i = 0; i < modulos.length; i++) {

      marker = new google.maps.Marker({
        position: new google.maps.LatLng(modulos[i][1], modulos[i][2]),
        map: map,
        icon: icon
      });
      bounds.extend(marker.position);

      google.maps.event.addListener(marker, 'click', (function (marker, i) {
      return function () {
        infowindow.setContent(modulos[i][0]);
        infowindow.open(map, marker);
      }
      })(marker, i));
      /** */
      ii=i+1;
      google.maps.event.addDomListener(document.getElementById('m-'+ii), 'click', function(e) {
        map.panTo({
          lat: parseFloat($(this).attr('lat')),
          lng: parseFloat($(this).attr('lon'))
        });
        map.setZoom(16);
      });
      /** */

    }

    map.fitBounds(bounds);
  }
}
window.initMap = initMap;

/* Aviso en la consola */
function antiXSS(){
  console.log("%c¡Detente!", "color: red; font-size:30px;");
  console.log("%cEsta funcionalidad del navegador es solo para desarrolladores.", "color: red; font-size:15px;");
  console.log("%cSi alguien te indicó que copiaras y pegaras algo aquí para acelerar el proceso de tu trámite o para \"saltarte\" una autorización, se trata de un engaño. Si lo haces, esta persona podrá acceder a los datos de tus solicitudes de trámite. Consulta https://es.wikipedia.org/wiki/Self-XSS para obtener más información.", "color: red; font-size:20px;");
}
$(document).ready(function(){
  if(document.querySelector('input[name="tp-persona"]')){
    toggleForm1();
  }
  //timercito = setInterval(laSesion, 5*60*1000); // minutostimer * 60 * 1000
  //setInterval(antiXSS, 60000); // minutostimer * 60 * 1000
  antiXSS();
  $('.tooltiptable').tooltip({html:true, trigger:'manual'});
  $('.radio-frm-datos-veh').on('click',toggleForm1);
  $('.radio-mismo-nombre').on('click',mismoNombreData);
  $('.to-uppercase').on('keyup', function(){ $(this).val($(this).val().toUpperCase()) });

  // Clave vehicular / carga
  $('.tsv').on('blur', function(){
    // minn = $(this).val().substring(0,1)=='0'?0:1;
    // maxx = $(this).val().substring(0,1)=='0'?0:3499;
    // cargaHelp = $(this).val().substring(0,1)=='0'?'Introducir un cero':'Capacidad de carga en Kg. 1 - 3499';
    minn = 0;
    maxx = 3499;
    cargaHelp = 'Capacidad de carga en Kg. 0 - 3499';

    $('#carga-help').html(cargaHelp);
    if($('#nuCapacidadCarga').length>0){
      $('#nuCapacidadCarga').attr('min', minn);
      $('#nuCapacidadCarga').attr('max', maxx);
    }
    if($('#nu_capacidad_carga').length>0){
      $('#nu_capacidad_carga').attr('min', minn);
      $('#nu_capacidad_carga').attr('max', maxx);
    }    
  });

  // Quitar guiones y espacios en la placa (consulta adeudos)
  $("#txPlacaConsulta").on('keydown blur change', function() {
    foo = $(this).val();
    bar = foo.replace(/[\s-]/g,"");
    
    $("#txPlacaConsulta").val(bar);
  });

  // 
  // $('#d-tx-serie-vehicular').on('click', function(e){
  //   $('#d-tx-marca').trigger('click');
  //   $('#d-tx-linea').trigger('click');
  //   $('#d-tx-version').trigger('click');
  //   $('#d-nu-capacidad-carga').trigger('click');
  // });

  $('.tooltiptable').on('click', function(e){
     var revisar = $(this);
    $.each($('.tooltiptable'), function( index, value ) {
      if($(value).attr('id')!==revisar.attr('id')){
        $(value).tooltip('hide');
      }
    });
    revisar.tooltip('toggle');
  });

  /*
  ** Funcion para buscar colonias y alcaldias por código postal
  **
  */	 
  $('#txCP, #tx_cp').on('blur', function(e){
    controlin = $(this).attr('id');
    var c_alcaldia = controlin == 'tx_cp'?'id_alcaldia':'idAlcaldia';
    var c_colonia = controlin == 'tx_cp'?'id_colonia':'idColonia';
    if(/^[0-9]{5}$/.test($(this).val())){
      var data = { "_token": token.content};
      $.ajax({
        url: ubase+'/service/u/alcaldiaColoniaByCP/'+this.value,
        dataType: 'json',
        type: 'POST',
        data: data,
        success: function(data) {
            // Quitar Alcaldía
            $('#'+c_alcaldia+' option').each(function() {
              if ( $(this).val() !== '' ) {
                $(this).remove();
              }
            });
            // Quitar Colonias
            $('#'+c_colonia+' option').each(function() {
              if ( $(this).val() !== '' ) {
                $(this).remove();
              }
            });
            arCodes=data.cp;
            if(arCodes.length === 0){
              crearMensaje(true,"Error","No es un código postal de CDMX");
              $('#txCP').val('');
            }else{

              idAlcaldia = data.alcaldia.id;
              nbAlcaldia = data.alcaldia.nb_alcaldia;
              $('#'+c_alcaldia).append('<option value="'+idAlcaldia+'">'+nbAlcaldia+'</option>');

              for(c=0;c<arCodes.length;c++){
                idColonia = arCodes[c].id;
                nbColonia = arCodes[c].nb_asentamiento;
                $('#'+c_colonia).append('<option value="'+idColonia+'">'+nbColonia+'</option>');
              }
            }
            
          },
          error: function(jqXHR, textStatus, errorThrown) {
            err = jqXHR.status ==419?'Tu sesión ha caducado, por favor inicia sesión de nuevo':"No pudimos <br>Código de error: " + jqXHR.status + " " + textStatus;
            crearMensaje(true,"Error",err);
          }
        }
      );
    }else{
      crearMensaje(true,"Error","No es un código postal válido");
      $(this).val('');
    }
  });

  /**
   * no enviar forms con enter
   */
  $('form input').keydown(function (e) {
    if (e.keyCode == 13) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
  });

/*
  ** Funcion para buscar linea vehiculo por id de marca
  **
  */	 
  $('#idMarca, #id_marca').on('change', function(e){
    controlin = $(this).attr('id');
    var c_marca = controlin == 'id_marca'?'id_marca':'idMarca';
    var c_linea = controlin == 'id_marca'?'id_linea':'idLinea';
    var c_version = controlin == 'id_marca'?'id_version':'idVersion';
    var data = { "_token": token.content};
    $.ajax({
      url: ubase+'/service/v/getLineaByMarca/'+this.value,
      dataType: 'json',
      type: 'POST',
      data: data,
      success: function(data) {
        // Quitar Linea
        $('#'+c_linea+' option').each(function() {
          if ( $(this).val() !== '' ) {
            $(this).remove();
          }
        });
        // Quitar Version
        $('#'+c_version+' option').each(function() {
          if ( $(this).val() !== '' ) {
            $(this).remove();
          }
        });
        arLineas=data.lineas;
        if(arLineas.length === 0){
          crearMensaje(true,"Error","No hay líneas de vehículo registradas para esta marca.");
        }else{
          for(c=0;c<arLineas.length;c++){
            idLinea = arLineas[c].id;
            nbLinea = arLineas[c].nb_linea;
            $('#'+c_linea).append('<option value="'+idLinea+'">'+nbLinea+'</option>');
          }
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        crearMensaje(true,"Error","No pudimos obtener la información <br>Código de error: " + jqXHR.status + " " + textStatus);
      }
    });
  });



  /*
  ** Muestra u oculta la ayuda para lo de la credencial de elector
  **
  */	 
  $('#id_cat_identificacion').on('change', function(e){
    controlin = $(this).attr('id');
    v = parseInt($('#'+controlin+' option').filter(':selected').val());
    if(v ===1){
      $('.ine-img-container').removeClass('d-none');
      $('#ine-c').attr('disabled', false);
      $('#ine-d').attr('disabled', false);
      $('#ine-e').attr('disabled', false);
      $('#btn-send').attr('disabled', true);
      $('#txFolioID').val($('#txFolioID').val().substring(0,9));
      $('#txFolioID').attr('maxlength', '18');
      // Solo para personas físicas
      tpPersona=document.querySelector('input[name="tp-persona"]:checked').value;
      if(tpPersona=='fisica'){
        $('.pregunta-domicilio').removeClass('d-none');
        $('#stMismoDomicilio').attr('disabled', false);
        $('#curpRepContainer').addClass('d-none');
      }
      if(tpPersona=='moral'){
        $('#txCurpRep').attr('disabled', false);
        $('#curpRepContainer').removeClass('d-none');
      }
    }else{
      $('.ine-img-container').addClass('d-none');
      $('#ine-c').attr('disabled', true);
      $('#ine-d').attr('disabled', true);
      $('#ine-e').attr('disabled', true);
      $('#btn-send').attr('disabled', false);
      $('#que-id').text('Folio de la identificación');
      $('#txFolioID').attr('placeholder', 'Escribe el folio');
      $('#txFolioID').attr('maxlength', '18');

      $('.ine-emision-container').addClass('d-none');
      $('.ine-ocr-container').addClass('d-none');

      $('#txEmisionIne').attr('disabled', true);
      $('#txOcrIne').attr('disabled', true);

      $('.pregunta-domicilio').addClass('d-none');
      $('#stMismoDomicilio').attr('disabled', true);

      $('#txCurpRep').attr('disabled', true);
    }

  });



  /*
  ** Muestra u oculta la parte de mismo domicilio
  **
  */	 
  $('#stMismoDomicilio').on('change', function(e){
    
    mismoDom = parseInt($('#stMismoDomicilio option').filter(':selected').val());
    if(mismoDom ===1){
      $('.mismo-dom-si').removeClass('d-none');
      $('.mismo-dom-no').addClass('d-none');
      $('#id_cat_comp_dom').attr('disabled', true);
      $('#biCompDomicilio').attr('disabled', true);
      $('#chkDomicilio').attr('disabled', true);
    }else{
      $('.mismo-dom-no').removeClass('d-none');
      $('.mismo-dom-si').addClass('d-none');
      $('#id_cat_comp_dom').attr('disabled', false);
      $('#biCompDomicilio').attr('disabled', false);
      if(parseInt($('#id_cat_comp_dom option').filter(':selected').val())==48){
        $('#chkDomicilio').attr('disabled', false);
      }

    }

  });



  /*
  ** Muestra u oculta la ayuda para lo de la credencial de elector
  **
  */	 
  $('#id_cat_comp_dom').on('change', function(e){
    controlin = $(this).attr('id');
    v = parseInt($('#id_cat_comp_dom option').filter(':selected').val());
    if(v ===48){ // Ninguno de los anteriores
      $('.con-comp-dom').addClass('d-none');
      $('.sin-comp-dom').removeClass('d-none');
      $('#chkDomicilio').attr('disabled', false);
      $('#biCompDomicilio').attr('disabled', true);
    }else{
      $('.con-comp-dom').removeClass('d-none');
      $('.sin-comp-dom').addClass('d-none');
      $('#chkDomicilio').attr('disabled', true);
      $('#biCompDomicilio').attr('disabled', false);
    }

  });




  /*
  ** Campos para cada tipo de credencial
  **
  */
  $('input[name="tp_ine"]').on('click', function(e){
    controlin = $(this).attr('id');
    switch(controlin){
      case 'ine-c':{
        $('#que-id').text('Clave de elector');
        $('#txFolioID').attr('placeholder', 'Escribe la clave de elector');
        // $('.id-folio-container').removeClass('d-none');
        $('.ine-emision-container').removeClass('d-none');
        $('.ine-ocr-container').removeClass('d-none');

        $('#txFolioID').attr('maxlength', '18');

        $('#txEmisionIne').attr('disabled', false);
        $('#txOcrIne').attr('disabled', false);
        break;
      }
      case 'ine-d':{
        $('#que-id').text('CIC');
        $('#txFolioID').attr('placeholder', 'Escribe el CIC');
        // $('.id-folio-container').removeClass('d-none');
        $('.ine-emision-container').addClass('d-none');
        $('.ine-ocr-container').addClass('d-none');

        $('#txFolioID').val($('#txFolioID').val().substring(0,9));
        $('#txFolioID').attr('maxlength', '9');

        $('#txEmisionIne').attr('disabled', true);
        $('#txOcrIne').attr('disabled', true);
        break;
      }
      case 'ine-e':{
        $('#que-id').text('CIC');
        $('#txFolioID').attr('placeholder', 'Escribe el CIC');
        // $('.id-folio-container').removeClass('d-none');
        $('.ine-emision-container').addClass('d-none');
        $('.ine-ocr-container').addClass('d-none');

        $('#txFolioID').val($('#txFolioID').val().substring(0,9));
        $('#txFolioID').attr('maxlength', '9');

        $('#txEmisionIne').attr('disabled', true);
        $('#txOcrIne').attr('disabled', true);
        break;
      }
    }
  });


  /*
  ** Modal con el ejemplo de la credencial seleccionada
  *
  */	 
  $('.ver-ine').on('click', function(e){
    kual = $(this).attr('id');
    ine = ubase+'/images/'+kual+'.jpg';
    $('#img-ejemplo-ine').attr('src', ine);
    $('#ejemplos-ine').modal('show');
  });



  /**
   * Validar datos de la credencial
   * 
   */
  $('#btn-validar-ine').on('click', function(e){
    // Ver qué tipo de credencial está seleccionada
    kual = $('input[name=tp_ine]:checked', '#frmNewVeh').val();
    tp = $('input[name=tp-persona]:checked').val();
    okas = true;
    if(kual != undefined){
      if('fisica' == tp){
        _curp = $('#txCurp').val();
      }else if('moral' == tp){
        _curp =$('#txCurpRep').val();;
      }
      switch(kual){
        case 'c':{
          if($('#txOcrIne').val() == '' || $('#txFolioID').val()=='' || $('#txEmisionIne').val()==''){
            okas = false;
            crearMensaje(true,"Error","Debes completar los campos de tu credencial", 5000);
          }else{
            payload = {
              claveElector: $('#txFolioID').val(),
              numeroEmisionCredencial: $('#txEmisionIne').val(),
              ocr: $('#txOcrIne').val(),
              curp: _curp,
              t:kual
            }            
          }
          break;
        }
        case 'd':{}
        case 'e':{
          if($('#txFolioID').val()==''){
            okas = false;
            crearMensaje(true,"Error","Escribe el CIC de tu credencial", 5000);
          }else{
            payload = {
              cic: $('#txFolioID').val(),
              t:kual,
              curp: _curp
            }
          }
          break;
        }
      }
      if(okas){
        $('#btn-send').attr('disabled', true);
        $('#modal-zagruzka').modal('show');
        $.ajax({
          url: ubase+'/service/ine/validar',
          dataType: 'json',
          contentType: 'application/json',
          type: 'POST',
          data: JSON.stringify(payload),
          success: function(data) {
            $('#validar-ine-ok').text(data.mensaje);
            $('#validar-ine-ok').removeClass('d-none');
            $('#validar-ine-no').addClass('d-none');
            $('#btn-validar-ine').text('Volver a validar');
            $('#btn-send').attr('disabled', false);
            $('#modal-zagruzka').modal('hide');
          },
          error: function(jqXHR, textStatus, errorThrown) {
            if(jqXHR.status !== 404){
              crearMensaje(true,"Error",jqXHR.responseJSON.mensaje + "<br>Código de error: " + jqXHR.status + " " + textStatus);
            }
            $('#validar-ine-no').text(jqXHR.responseJSON.mensaje);
            $('#validar-ine-no').removeClass('d-none');
            $('#validar-ine-ok').addClass('d-none');
            $('#btn-validar-ine').text('Volver a validar');
            $('#btn-send').attr('disabled', true);
            $('#txOcrIne').val('');
            $('#txFolioID').val('');
            $('#txEmisionIne').val('');
            $('#modal-zagruzka').modal('hide');
          }
        });
      }

    }else{
      crearMensaje(true,"Error","Debes seleccionar el modelo de tu credencial y completar los campos correspondientes", 5000);
    }
  });


  /**
   * ajax para validar la curp
   */
  $('#txCurp').on('keyup blur', function (e) {
    if ($(this).val() != '' && /^(([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d))$/.test($(this).val())) {
      var laCurp = $(this).val();
      $.ajax({
        url: uCURP,
        dataType: 'json',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          tx_curp: $(this).val()
        }),
        success: function (data) {
          $('#txNombre').val(data.txNombres);
          $('#txApellidoPat').val(data.txApellidoPaterno);
          $('#txApellidoMat').val(data.txApellidoMaterno);
          $('#txRfc').val(laCurp.substring(0,10));
          $('#btn-send').attr('disabled', false);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          err = jqXHR.status == 419 ? 'Tu sesión ha caducado, por favor inicia sesión de nuevo' : jqXHR.responseJSON.message || jqXHR.responseJSON.respuesta;
          $('#txNombre').val('');
          $('#txApellidoPat').val('');
          $('#txApellidoMat').val('');
          $('#txRfc').val('');
          $('#btn-send').attr('disabled', true);
          crearMensaje(true, "Error", err);
        }
      });
    }else{
      $('#txNombre').val('');
      $('#txApellidoPat').val('');
      $('#txApellidoMat').val('');
      $('#txRfc').val('');
      $('#btn-send').attr('disabled', true);
    }
  });


  /**
   * Funcion para alternar el disabled de la lista de validador por tramite
   */
   $('.chk-select-validator').on('click', function(){
    kuantas = $('.chk-select-validator:checked').length;
    marcaTodas = kuantas == $('.chk-select-validator').length;
    if(marcaTodas){
      $('#check-seleccionar-todo').prop('checked', true)
    }else{
      $('#check-seleccionar-todo').prop('checked', false)
    }
    if(kuantas >=2){
      $('#validators-all').attr('disabled', false);
      $('.validators').attr('disabled', true);
    }else if(kuantas==1){
      $('#validators-all').attr('disabled', false);
      $('.chk-select-validator').each(function(){
        kual = this.value;
        c = this.checked;
        $('#validators-'+kual).attr('disabled', !c);
      });
    }else{
      $('#validators-all').attr('disabled', true);
      $('.validators').attr('disabled', true);
    }
  });

  /**
   * Funcion para cambiar todos los checks de validadores
   */
  $('#check-seleccionar-todo').on('click', function(){
    kha = $('#check-seleccionar-todo').prop('checked');
    $('.chk-select-validator').prop('checked', kha);
    $('#validators-all').attr('disabled', !kha);
    $('.validators').attr('disabled', true);
  });

  $('#btn-select-all').on('click', function(){ $('#check-seleccionar-todo').trigger('click') });

  /**Mostrar el modal para un tramite
   */
  $('.validators').on('change', function(e){
    val = $(this).val();
    sol = $(this).attr('id');
    partes=sol.split('-');
    iSol = parseInt(partes[1]);
    if(val.trim() !==''){
      $('#toValidator').val(val);
      $('#asignar-action').val(1);
      $('#k').val(iSol);
      $('#pregunta-asignar').text('¿Deseas asignar la solicitud de trámite al validador seleccionado?');
      $('#modalConfirmAsignar').modal('show');
    }
  });

  /**
   * Mostrar el modal para todos los trámites
   */
   $('#validators-all').on('change', function(e){
    kuantas = $('.chk-select-validator:checked').length;
    val = $(this).val();
    if(val.trim() !==''){
      $('#toValidator').val($('#validators-all').val());
      $('#asignar-action').val(2);
      $('#k').val(0);
      $('#pregunta-asignar').text('¿Deseas asignar '+kuantas+' solicitudes de trámite al validador seleccionado?');
      $('#modalConfirmAsignar').  modal('show');
    }
  });


  /**
   * Boton asignar (1 o muchos tramites)
   */
  $('#st_si').on('click', function(e){
    $('#modal-zagruzka').modal('show');
    a = parseInt($('#asignar-action').val());
    zelected = [];
    if(2 ==  a){
      // recolectar ids de los checks seleccionados
      $( ".chk-select-validator:checked" ).each(function( index ) {
        sol = $(this).attr('id');
        partes=sol.split('-');
        iSol = parseInt(partes[2]);
        zelected.push(iSol);
      });
    }
    $.ajax({
      url: uSuAsig,
      dataType: 'json',
      contentType: "application/json",
      type: 'POST',
      data: JSON.stringify({
        k: $('#k').val(),
        toValidator: $('#toValidator').val(),
        _action: a,
        ids: zelected
      }),
      success: function(data) {
        location.reload();
      },
      error: function(jqXHR, textStatus, errorThrown) {
        $('#modal-zagruzka').modal('hide');
        crearMensaje(true,"Error",jqXHR.responseJSON.mensaje+" <br>Código de error: " + jqXHR.status);
      }
    });
  });


  /**
   * Link regresa a Validación
   */
   $('.regresa-validar').on('click', function(e){
    sol = $(this).attr('id');
    partes=sol.split('-');
    iSol = parseInt(partes[1]);
    $('#kID').val(iSol);
    $('#modalConfirm').modal('show');
  });

////////////////////////////////////////////////////////////////////

  /*
    ** Funcion para buscar version del vehiculo por  id de linea
    **
    */	 
  $('#idLinea, #id_linea').on('change', function(e){
    controlin = $(this).attr('id');
    var c_linea = controlin == 'id_linea'?'id_linea':'idLinea';
    var c_version = controlin == 'id_linea'?'id_version':'idVersion';
    var data = { "_token": token.content};
    $.ajax({
      url: ubase+'/service/v/getVersionByLinea/'+this.value,
      dataType: 'json',
      type: 'POST',
      data: data,
      success: function(data) {
        // Quitar Version
        $('#'+c_version+' option').each(function() {
          if ( $(this).val() !== '' ) {
            $(this).remove();
          }
        });
        arVersiones=data.versiones;
        if(arVersiones.length === 0){
          crearMensaje(true,"Error","No hay versiones de vehículo registradas para esta línea.");
        }else{
          for(c=0;c<arVersiones.length;c++){
            idVersion = arVersiones[c].id;
            nbVersion = arVersiones[c].tx_version;
            $('#'+c_version).append('<option value="'+idVersion+'">'+nbVersion+'</option>');
          }
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        crearMensaje(true,"Error","No pudimos obtener la información <br>Código de error: " + jqXHR.status + " " + textStatus);
      }
    });
  });


  /**
   * Funcion para alternar el action del form
   */
  $('.trigger').on('click', function(){
    what=parseInt($(this).attr('authenticable'))==1?$('#div-flag').attr('authenticate-with'):$('#div-flag').attr('public')
    $('#frmSelectDetalle').attr('action',what);
  });

  /**
   * Lanzar el selector de archivos cuando le den a Seleccionar archivo
   */
  $('.file-picker').on('click', function(){
    o=$(this).attr('catch');
    $('#get-file-error-' + o).addClass('d-none');
    verMsg = parseInt($(this).attr('ver-msg'));
    if(verMsg==1){
      $('#sc-' + o).removeClass('from-expediente');
    }else{
      $('#sc-' + o).addClass('from-expediente');
    }
    
    $('#isFromExp-'+ o).val('');
    $('#'+o).trigger('click');
  });

  /**
   * Aviso de tamaño máximo de archivo
   */
  $("input[type=file]").on("change", function(e){

  var file = this.files[0],
  fileName = file.name,
  fileSize = file.size;
  kb=fileSize/1024;
  if(kb>7168){
    this.value='';
    alert(fileName + ', este archivo no será cargado porque excede el tamaño permitido de 7 megas.');
  }
  });



  /**
   * Numeros en notacion cientifica a normal
   */
  $("input[type=number]").on("blur", function(){
    this.value = Number(this.value).toPrecision();
  });

  /**
   * Borra el nombre anterior en el file
   */
  $('.datos-veh-file-control').on('click', function(e){
    $(this).val('');
    $('#controls-' + $(this).attr('id')).addClass('d-none');
    $('#filename-' + $(this).attr('id') ).html('');
  });

  /**
   * Poner nombre del archivo en el contenedor
   */
  $('.datos-veh-file-control').on('change', function(e){
    obj = $(this).attr('id');
    baz = $(this).val();
    if(baz===''){
      val= '';
    }else{
      val = document.getElementById($(this).attr('id')).files.item(0).name
      $('#v-'+obj ).val(val); // Oldies
      $('#controls-'+obj).removeClass('d-none');
      $('#filename-'+obj).html(val);
      //
      const leId = this.id;
      if(this.files.length >0 ){
          const file = this.files[0];
          const reader = new FileReader();
          const fileName = file.name;
          reader.readAsDataURL(file);
          reader.onload = function () {
              b64 = reader.result;
              console.log(reader.result);
              b64 = b64.replace('data:application/pdf;base64,','');
              b64 = b64.replace('data:application/octet-stream;base64,','');
              bloob = b64toBlob(b64, file.type);
              $('#view-'+leId).attr('href',URL.createObjectURL(bloob));
          };
          reader.onerror = function (error) {
              alert('Ocurrió un  error al leer el archivo ' + fileName);
          };
      }else{

      }
      //
    }
  });

  /**
   * Mostrar dialogs
   */
  $('.modal-placa').on('click', function(e){
    $('#frmSelectDetalle').attr('disabled', true);
    $('#buscar-adeudos-modal').modal({
      backdrop: 'static',
      keyboard: false
    });
  });

  if($('#avisos-alta').length > 0){
    $('#avisos-alta').modal({
      backdrop: 'static',
      keyboard: false
    });
  }

  /**
   * 
   */
  if($('#mostrar-modal-placa').length > 0){
    $('#buscar-adeudos-modal').modal({
      backdrop: 'static',
      keyboard: false
    });
  }

  /**
   * Boton de buscar sanciones
   */
  $('#searchAdeudos').on('click',function(e){
    plaquita = $('#txPlacaConsulta').val();
    $('#res-civicas').removeClass('adeuda no-adeuda');
    $('#res-tenencias').removeClass('adeuda no-adeuda');
    $('#res-ambientales').removeClass('adeuda no-adeuda');
    $('#res-monetarias').removeClass('adeuda no-adeuda');
    if(plaquita=="" || plaquita.length<3){
      crearMensaje(true,"Error","Debes introducir un número de placa");
    }else{
      $('#searchAdeudos').attr('disabled', true);
      $.ajax({
        url: ubase+'/service/v/getSanciones/'+plaquita,
        dataType: 'json',
        type: 'GET',
        success: function(data) {
          $('#mini-form-adeudos').hide('slow');
          $('#resultado-adeudos').show('slow');
          $('#searchAdeudos').hide('slow');
          
          $('#busca-otro-adeudo').show('slow');
          civicas = data.adeudo_fotocivicas.adeudo_fotocivicas?'Con adeudos':'Sin adeudos';
          tenencias = data.adeudo_tenencia?'Con adeudos':'Sin adeudos';
          ambientales = data.adeudo_sancion?'Con adeudos':'Sin adeudos';
          infracciones = data.adeudo_infraccion?'Con adeudos':'Sin adeudos';
          if(    !data.adeudo_fotocivicas.adeudo_fotocivicas
              && !data.adeudo_tenencia
              && !data.adeudo_sancion
              /* && !data.adeudo_infraccion */){
                $('#entendido').show('slow');
                if($('#txPlacaAnterior').length > 0){
                  $('#txPlacaAnterior').val(''+plaquita);
                }
          }
          // CSS
          civicas_c = data.adeudo_fotocivicas.adeudo_fotocivicas?'adeuda':'no-adeuda';
          tenencias_c = data.adeudo_tenencia?'adeuda':'no-adeuda';
          ambientales_c = data.adeudo_sancion?'adeuda':'no-adeuda';
          infracciones_c = data.adeudo_infraccion?'adeuda':'no-adeuda';

          $('#h-placa').text('Placa ' + plaquita);

          $('#res-civicas').text(civicas);
          $('#res-tenencias').text(tenencias);
          $('#res-ambientales').text(ambientales);
          $('#res-monetarias').text(infracciones);
          //CSS
          $('#res-civicas').addClass(civicas_c);
          $('#res-tenencias').addClass(tenencias_c);
          $('#res-ambientales').addClass(ambientales_c);
          $('#res-monetarias').addClass(infracciones_c);

        },
        error: function(jqXHR, textStatus, errorThrown) {
          crearMensaje(true,"Error","No pudimos obtener la información de adeudos para la placa introducida");
        }
      });
      $('#searchAdeudos').attr('disabled', false);
    }
  });

  /**
   * Buscar otro adeudo
   */
  $('#busca-otro-adeudo').on('click', function(e){
    $('#txPlacaConsulta').val('');
    $('#mini-form-adeudos').show('slow');
    $('#resultado-adeudos').hide('slow');
    $('#searchAdeudos').show('slow');
    $('#entendido').hide('slow');
    $('#busca-otro-adeudo').hide('slow');
  });

  /**
   * Buscar adeudo en botón de correccion
   */
  $('.c-placa').on('blur',function(e){
    plaquita = $(this).val();
    var o_o = $(this);
    if(plaquita=="" || plaquita.length<3){
      crearMensaje(true,"Error","Debes introducir un número de placa");
    }else{
      $.ajax({
        url: ubase+'/service/v/getSanciones/'+plaquita,
        dataType: 'json',
        type: 'GET',
        success: function(data) {
          civicas = "Fotocívicas: " + (data.adeudo_fotocivicas.adeudo_fotocivicas?'Con adeudos':'Sin adeudos');
          tenencias = "Tenencias: " + (data.adeudo_tenencia?'Con adeudos':'Sin adeudos');
          ambientales = "Sanciones ambientales: " + (data.adeudo_sancion?'Con adeudos':'Sin adeudos');
          infracciones = "Infracciones: " + (data.adeudo_infraccion?'Con adeudos':'Sin adeudos');
          if(    data.adeudo_fotocivicas.adeudo_fotocivicas
              || data.adeudo_tenencia
              || data.adeudo_sancion
              /*|| data.adeudo_infraccion*/){
                
                  m = "Para realizar los cambios se requiere introducir una placa que no tenga ningun tipo de adeudo. Para la placa que especificaste, encontramos lo siguiente:\r\n\r\n";
                  m += "- "+civicas + '\r\n';
                  m += "- "+tenencias + '\r\n';
                  m += "- "+ambientales + '\r\n';
                  m += "- "+infracciones + '\r\n';
                  alert(m);
                  o_o.val('');
                
          }
          // CSS
          civicas_c = data.adeudo_fotocivicas.adeudo_fotocivicas?'adeuda':'no-adeuda';
          tenencias_c = data.adeudo_tenencia?'adeuda':'no-adeuda';
          ambientales_c = data.adeudo_sancion?'adeuda':'no-adeuda';
          infracciones_c = data.adeudo_infraccion?'adeuda':'no-adeuda';

          $('#h-placa').text('Placa ' + plaquita);

          $('#res-civicas').text(civicas);
          $('#res-tenencias').text(tenencias);
          $('#res-ambientales').text(ambientales);
          $('#res-monetarias').text(infracciones);
          //CSS
          $('#res-civicas').addClass(civicas_c);
          $('#res-tenencias').addClass(tenencias_c);
          $('#res-ambientales').addClass(ambientales_c);
          $('#res-monetarias').addClass(infracciones_c);

        },
        error: function(jqXHR, textStatus, errorThrown) {
          crearMensaje(true,"Error","No pudimos obtener la información de adeudos para la placa introducida");
        }
      });
      $('#searchAdeudos').attr('disabled', false);
    }
  });

  $('#entendido').on('click', function(e){$('#frmSelectDetalle').attr('disabled', false)});

  /**
   * Visor de archivos
   */
  $('#fv-modal').on('show.bs.modal', function (event) {
    var v = $(event.relatedTarget);
    uuid=v.data('file-viewer-id');
    newURL = ubase + '/service/storage/file/' + uuid;
    $('object').remove();
    $('<object id="fv-content" data="'+newURL+'"></object>').appendTo('#fv-modal .modal-body');
    //$('#fv-content').attr('data',newURL);
  });

  /**
   * Botones de check o declinar
  */
  $(document).on('click', '.a-check, .a-decline', function(e){
    if($('#method').length > 0){
      method=$('#method').val();
    }else{
      method='operador';
    };
    e.preventDefault();
    ele=$(this);
    hElement = ele.attr('handle');
    iElement = ele.attr('id');
    text_area = ele.attr('vt');
    avisoDepende = ele.attr('dep');
    old_c = $('#'+iElement).hasClass('fondo-verde');
    old_d = $('#'+iElement).hasClass('fondo-rojo');
    //Enviar data aquí
    $.ajax({
      url: ubase+'/'+method+'/setStatus/'+$('#s').val()+'/'+iElement,
      dataType: 'json',
      type: 'POST',
      data:{
        "_token":token.content,
        "old_c": old_c,
        "old_d": old_d
      },
      success: function(data) {
        $('#'+hElement).removeClass('fondo-verde').removeClass('fondo-rojo');
        if(ele.hasClass('a-check')){
          ele.toggleClass('fondo-verde');
        }else if(ele.hasClass('a-decline')){
          ele.toggleClass('fondo-rojo');
        }

        if('obs_repuve'==text_area){
          if($('#c-tx-vin').hasClass('fondo-verde') && $('#c-tx-placa-anterior').hasClass('fondo-verde')){
            $('#'+text_area).attr('disabled',true);
          }else{
            $('#'+text_area).attr('disabled',false);
          }
        }else{
          if(ele.hasClass('fondo-rojo')){
            $('#'+text_area).attr('disabled',false);
          }else if(ele.hasClass('fondo-verde')){
            $('#'+text_area).attr('disabled',true);
          }else{
            $('#'+text_area).attr('disabled',false);
          }
        }
        // Avisos
        if(avisoDepende != 'undefined'){
          if(ele.hasClass('fondo-rojo')){
            $('#'+avisoDepende).show('slow');
          }else{
            $('#'+avisoDepende).hide('slow');
          }
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(jqXHR.status ==419){txError = 'La sesión ha caducado, es necesario que inicies sesión de nuevo';}else{txError = "No pudimos procesar la solicitud"}
        crearMensaje(true,"Error",txError);
      }
    });
  });

  /**
   * Validador, no procede el trámite
   * mostrar modal
   */
  $('#btn-no-procede').on('click', function(e){
    event.preventDefault();
    event.stopPropagation();
    $('#noProcede').modal({
      backdrop: 'static',
      keyboard: false
    });
  });

  /**
   * Botón cerrar trámite porque no procede
   * enviar data
   */
  $('#btn-send-no-procede').on('click', function(e){
    if(confirm('Si marcas el trámite como no procedente el ciudadano deberá realizar uno nuevo\n¿Deseas continuar?')){
      dataz = $('#frmValidarSeccion').serializeArray();
      dataSend = {
        "_token": token.content,
        'formulario': dataz,
        'chkLegal':$('#chk-legal').prop('checked'),
        "motivo":$('#detalles-no-procede').val()
      };
      if($('#detalles-no-procede').val() != ''){
        $.ajax({
          url: ubase + '/operador/valida/alta/no-procede',
          dataType: 'json',
          contentType: 'application/json',
          type: 'POST',
          data: JSON.stringify(dataSend),
          headers: {
            'X-CSRF-TOKEN': token.content
          },

          success: function(data) {
            if(data.ok){
              crearMensaje(false,"Mensaje del sistema",""+data.mensaje);
              location.href=ubase+'/operador/valida/alta/no-procede';
            }else{
              crearMensaje(true,"Error",""+data.mensaje)
            }
            
          },
          error: function(jqXHR, textStatus, errorThrown) {
            crearMensaje(true,"Error","No pudimos obtener la información <br>Código de error: " + jqXHR.status + " " + textStatus);
          }
        });
      }else{
        crearMensaje(true,'Error','Debes especificar por qué no procede el trámite');
      }
    }
  });

  /**
   * Botón cerrar trámite porque no procede (Entrega)
   * enviar data
   */
  $('#btn-send-no-entrega').on('click', function(e){
    if(confirm('Si marcas el trámite como no procedente el ciudadano deberá realizar uno nuevo\n¿Deseas continuar?')){
      
      dataSend = {"_token": token.content, 'chkLegal':$('#chk-legal').prop('checked'), "motivo":$('#detalles-cancelacion').val(), "s":$('#s').val()};
      if($('#detalles-cancelacion').val() != ''){
        $.ajax({
          url: ubase + '/entrega/no-procede',
          dataType: 'json',
          contentType: 'application/json',
          type: 'POST',
          data: JSON.stringify(dataSend),
          headers: {
            'X-CSRF-TOKEN': token.content
          },

          success: function(data) {
            if(data.ok){
              crearMensaje(false,"Mensaje del sistema",""+data.mensaje);
              location.href=ubase+'/entrega/no-procede';
            }else{
              crearMensaje(true,"Error",""+data.mensaje)
            }
            
          },
          error: function(jqXHR, textStatus, errorThrown) {
            crearMensaje(true,"Error","No pudimos obtener la información <br>Código de error: " + jqXHR.status + " " + textStatus);
          }
        });
      }else{
        crearMensaje(true,'Error','Debes especificar por qué se cancela el trámite');
      }
    }
  });

  /**
   * Botón cerrar no entregar por documentos incompletos
   * enviar data
   */
  $('#btn-send-incompleto').on('click', function(e){
    if(confirm('Vas a indicar que los aditamentos no fueron entregados por falta de documentacion. el ciudadano podrá recogerlos después\n¿Deseas continuar?')){
      
      dataSend = {"_token": token.content, "motivo":$('#detalles').val(), "s":$('#s').val()};
      if($('#detalles').val() != ''){
        $.ajax({
          url: ubase + '/entrega/documentacion-incompleta',
          dataType: 'json',
          contentType: 'application/json',
          type: 'POST',
          data: JSON.stringify(dataSend),
          headers: {
            'X-CSRF-TOKEN': token.content
          },

          success: function(data) {
            if(data.ok){
              crearMensaje(false,"Mensaje del sistema",""+data.mensaje);
              location.href=ubase+'/entrega/documentacion-incompleta';
            }else{
              crearMensaje(true,"Error",""+data.mensaje)
            }
            
          },
          error: function(jqXHR, textStatus, errorThrown) {
            crearMensaje(true,"Error","No pudimos obtener la información <br>Código de error: " + jqXHR.status + " " + textStatus);
          }
        });
      }else{
        crearMensaje(true,'Error','Debes especificar por qué se cancela el trámite');
      }
    }
  });

  /**
   * Validador, enviar al ciudadano a revisión
   * Mostrar modal
   */
  $('#btn-revisar').on('click', function(e){
    event.preventDefault();
    event.stopPropagation(); //
    $('#enviaRevision').modal({
      backdrop: 'static',
      keyboard: false
    });
  });

  /**
   * Botón enviar a revisión
   * enviar data
   */
  $('#btn-send-revision').on('click', function(e){
    dataz = $('#frmValidarSeccion').serializeArray();
    if($('#detalles-enviar-revision').val() != ''){
      dataSend = {
        "_token": token.content
        ,'detalles_revision':$('#detalles-enviar-revision').val()
        ,'formulario': dataz
      };
      $.ajax({
        url: ubase + '/operador/valida/alta/enviar-revision',
        dataType: 'json',
        contentType: 'application/json',
        type: 'POST',
        data: JSON.stringify(dataSend),
        headers: {
          'X-CSRF-TOKEN': token.content
        },

        success: function(data) {
          if(data.ok){
            crearMensaje(false,"Mensaje del sistema",""+data.mensaje);
            location.href=ubase+'/operador/valida/alta/enviar-revision';
          }else{
            crearMensaje(true,"Error",""+data.mensaje)
          }
          
        },
        error: function(jqXHR, textStatus, errorThrown) {
          crearMensaje(true,"Error","No pudimos obtener la información <br>Código de error: " + jqXHR.status + " " + textStatus);
        }
      });
    }else{
      crearMensaje(true,'Error','Debes especificar por qué se envía a revisión');
    }
  });

  /**
   * Mandar a login si la sesión caducó
   */
  $('#relogi').on('click', function(e){
    event.preventDefault();
    event.stopPropagation();
    location.href=uHome;
  });

  /**
   * Alternar vista en el formulario de documentos tercero
   */
  $('input[name=optRecolectaPlacas]').on('click', function(e){
    if(e.target.value == 'alguien'){
      $('.toggleable').attr('disabled', false);
      $('#form-quien').show('slow');
      $('#no-mas').hide('slow');
    }else{
      $('.toggleable').attr('disabled', true);
      $('#form-quien').hide('slow');
      $('#no-mas').show('slow');
    }
  });

  /**
   * Tablas de las bandejas
   */
  $('#main-table').dataTable( {
    paginate: false,
    bFilter: false,
    bInfo : false
  } );

  /**
   * Campos del buscador
  */
  $('#set-fh-inicio').on('click', function (e){
    $('#c-date-ini').toggle('fast');
    if (  $( '#flecha-ini' ).css( "transform" ) == 'none' ){
      $('#flecha-ini').css("transform","rotate(270deg)");
    } else {
      $('#flecha-ini').css("transform","" );
    }
    $('#c-date-fin').hide('fast');
    $('#flecha-fin').css("transform","" );
    $('#cmbStatus').hide('fast');
    $('#flecha-estatus').css("transform","" );
  });

  $('#set-fh-fin').on('click', function (e){
    $('#c-date-fin').toggle('fast');
    if (  $( '#flecha-fin' ).css( "transform" ) == 'none' ){
      $('#flecha-fin').css("transform","rotate(270deg)");
    } else {
      $('#flecha-fin').css("transform","" );
    }
    $('#c-date-ini').hide('fast');
    $('#flecha-ini').css("transform","" );
    $('#cmbStatus').hide('fast');
    $('#flecha-estatus').css("transform","" );
  });

  $('#set-estatus').on('click', function (e){
    $('#cmbStatus').toggle('fast');
    if (  $( '#flecha-estatus' ).css( "transform" ) == 'none' ){
      $('#flecha-estatus').css("transform","rotate(270deg)");
    } else {
      $('#flecha-estatus').css("transform","" );
    }
    $('#c-date-fin').hide('fast');
    $('#flecha-fin').css("transform","" );
    $('#c-date-ini').hide('fast');
    $('#flecha-ini').css("transform","" );
  });

  $('#c-date-ini').on('change', function (e){
    $('#fhInicio').val($(this).val());
  });
  $('#c-date-fin').on('change', function (e){
    $('#fhFin').val($(this).val());
  });
  $('#cmbStatus').on('change', function (e){
    $('#idEstatus').val($(this).val());
  });


  /*
  ** Busqueda por VIN
  */	 
  $('#txVIN, #tx_vin').on('blur', function(e){
    $('#res-VIN').html('<p class="lbl-dialog">Estamos validando el VIN, esto puede tardar un poco. Por favor espera...</p><img src="'+ubase+'/images/loader.gif" class="mx-auto d-block adip-loader-gif">');
    controlin = $(this).attr('id');
    controlNCI = controlin=='txVIN'?'txNciRepuve':'tx_nci_repuve';
    if($(this).val()==''){
    }else if(/^[A-Z\d]{9,17}$/.test($(this).val())){
      // Modalin
      $('#buscar-vin-modal').modal({
        backdrop: 'static',
        keyboard: false,
        show: false
      });
      $('#buscar-vin-modal').modal('show');
      //
      var klose=true;
      $.ajax({
        url: ubase+'/service/v/getVehicleInfo/'+$(this).val(),
        dataType: 'json',
        type: 'GET',
        success: function(data) {
          $('#buscar-vin-modal').modal('hide');
          $('#'+ controlNCI).val(data.nci);
          //$('#txNciRepuve').val(data.nci);  
        },
        error: function(jqXHR, textStatus, errorThrown) {
          switch(jqXHR.status){
            case 401:{}
            case 419:{
              err = 'Tu sesión ha caducado, por favor inicia sesión de nuevo';
              break;
            }
            case 422:{
              err = 'VIN no encontrado en REPUVE';
              alert('No encontramos tu vehículo en REPUVE. Por favor verifica el VIN e intenta de nuevo');
              break;
            }
            case 400:{
              err = jqXHR.responseJSON.mensaje;
              klose=true;
              $('#res-VIN').html('<p>'+err+'.</p><p>No es posible registrar más de una vez el mismo vehículo.</p><p><a href="" id="rp">Actualizar la página</a> para probar con otro VIN</p>');
              $('#rp').attr('href',controlin === 'txVIN'?$('#res-VIN').attr('route'):'');
              break;
            }
            case 434:{}
            case 412:{
              err = jqXHR.responseJSON.mensaje;
              klose=false;
              $('#res-VIN').html('<p>Tu vehículo cuenta con un registro en el padrón de la CDMX. Por el momento, el trámite de alta usado no se encuentra disponible. </p><p>También puedes <a href="" id="rp">actualizar la página</a> y probar con otro VIN</p>');
              $('#rp').attr('href',controlin === 'txVIN'?$('#res-VIN').attr('route'):'');
              break;
            }
            case 451:{
              err = jqXHR.responseJSON.mensaje;
              cid = jqXHR.responseJSON.correlation_id;
              klose=false;
              $('#res-VIN').html('<p>Tu vehículo es un caso especial, por lo que tendrás que acudir a un módulo para realizar el trámite de forma presencial . <a href="'+ubase+'/modulos-semovi" target="_blank">Ver módulos</a></p><p>También puedes <a href="" id="rp">actualizar la página</a> y probar con otro VIN</p><p><small><strong>ID de incidencia: '+cid+'</strong></small></p>');
              $('#rp').attr('href',controlin === 'txVIN'?$('#res-VIN').attr('route'):'');
              break;
            }
            case 406:{
              err = jqXHR.responseJSON.mensaje;
              cid = jqXHR.responseJSON.correlation_id;
              klose=false;
              $('#res-VIN').html('<p>Tu vehículo cuenta con un registro previo en el padrón de la CDMX. Por el momento, el trámite de alta usado no se encuentra disponible. </p><p>También puedes <a href="" id="rp">actualizar la página</a> y probar con otro VIN</p>');
              $('#rp').attr('href',controlin === 'txVIN'?$('#res-VIN').attr('route'):'');
              break;
            }
            case 409:{}
            case 500:{
              err = 'El servicio de consulta de vehículos con reporte de robo presenta intermitencia. Estamos trabajando para solucionarlo, intenta más tarde';
              break;
            }
            default:{
              err = 'No pudimos procesar la solicitud<br>Código de error: ' + jqXHR.status + ' ' + textStatus;
              break;
            }
          }
          crearMensaje(true,"Error",err);
          $('#'+controlin).val('');
          if(klose){$('#buscar-vin-modal').modal('hide');}
        }
      });
    }else{
      crearMensaje(true,"Error",'No es un VIN válido');
      $('#'+controlin).val('');
    }
  });

  /*
  ** Busqueda por clave vehicular
  */	 
  $('#txSerieVehicular, #tx_serie_vehicular').on('blur', function(e){
    controlSerie = $(this).attr('id')=='txSerieVehicular'?'txSerieVehicular':'tx_serie_vehicular';
    controlMarca = $(this).attr('id')=='txSerieVehicular'?'idMarca':'tx_marca';
    controlLinea = $(this).attr('id')=='txSerieVehicular'?'idLinea':'tx_linea';
    controlVersion = $(this).attr('id')=='txSerieVehicular'?'idVersion':'tx_version';

    $('#'+controlMarca).val('');
    $('#'+controlLinea).val('');
    $('#'+controlVersion).val('');
    if($('#'+controlSerie).val()!==''){
      $.ajax({
        url: ubase+'/service/v/getVehicleInfoCV/'+$('#'+controlSerie).val(),
        dataType: 'json',
        type: 'GET',
        success: function(data) {
          cd = parseInt(data.result.claseDigito);
          // if(cd !== 0 && cd !==1){
          //   crearMensaje(true,"Error",'Este trámite sólo está disponible para vehículos de uso particular');
          //   $('#'+controlSerie).val('');
          // }else{
            $('#'+controlMarca).val(data.result.marcaEmpresa);
            $('#'+controlLinea).val(data.result.lineaModelo);
            $('#'+controlVersion).val(data.result.version);
          // }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          switch(jqXHR.status){
            case 419:{
              err = 'Tu sesión ha caducado, por favor inicia sesión de nuevo';
              break;
            }
            case 404:{
              err = 'La clave vehicular buscada no fue encontrada';
              break;
            }
            default:{
              err = jqXHR.responseJSON.mensaje;
              break;
            }
          }
          crearMensaje(true,"Error",err);
          $('#'+controlSerie).val('');
        }
      });
    }
  });

  /*
  ** Busqueda de tipo de vehiculo por clase
  */	 
  $('#idClase, #id_clase').on('change', function(e){
    controlClase = $(this).attr('id')== 'idClase'?'idClase':'id_clase';
    controlTipo = $(this).attr('id')== 'idClase'?'idTipo':'id_tipo';
    if($('#'+controlClase).val()!==''){
      $.ajax({
        url: ubase+'/service/v/getClaseVehByTipo/'+$('#'+controlClase).val(),
        dataType: 'json',
        type: 'GET',
        success: function(data) {
          clases = data.result
          // Quitar los que estan
          $('#'+controlTipo+' option').each(function() {
            if ( $(this).val() !== '' ) {
              $(this).remove();
            }
          });
          // Volver a llenar
          for(c=0;c<clases.length;c++){
            idClase = clases[c].id;
            txTipo = clases[c].tx_tipo;
            $('#'+controlTipo).append('<option value="'+idClase+'">'+txTipo+'</option>');
          }
          
        },
        error: function(jqXHR, textStatus, errorThrown) {
          switch(jqXHR.status){
            case 419:{
              err = 'Tu sesión ha caducado, por favor inicia sesión de nuevo';
              break;
            }
            default:{
              err = 'No pudimos procesar la solicitud<br>Código de error: ' + jqXHR.status + ' ' + textStatus;
              break;
            }
          }
          crearMensaje(true,"Error",err);
          $('#'+controlClase).val('');
        }
      });
    }
  });

  /**
   * Botones para documentos de baja
   * Tarjeta de circulacion 
   */
  //
  $(document).on('click', '#has-tarjeta-si, #has-tarjeta-no', function(e){
    e.preventDefault();
    ele=$(this);
    iElementTarjeta = ele.attr('id');

    if (iElementTarjeta == 'has-tarjeta-si') {
      clasTarjeta = 'fondo-verde';
      $('#has-tarjeta-no').removeClass('fondo-rojo');
      $('#biTarjetaC').attr('disabled', false);
      $('#biMpTarjeta').attr('disabled', true);
      //$('#hasTarjeta').attr('disabled', true);
      $('.handledByTarjetaSi').show('slow');
      $('.handledByTarjetaNo').hide('slow');
      valTarjeta = 1;
    } else if (iElementTarjeta == 'has-tarjeta-no') {
      clasTarjeta = 'fondo-rojo';
      $('#has-tarjeta-si').removeClass('fondo-verde');
      $('#biTarjetaC').attr('disabled', true);
      $('#biMpTarjeta').attr('disabled', false);
      //$('#hasTarjeta').attr('disabled', false);
      $('.handledByTarjetaSi').hide('slow');
      $('.handledByTarjetaNo').show('slow');
      valTarjeta = 0;
    }
    neu_clas = $('#'+iElementTarjeta).addClass(clasTarjeta);
    $('#hasTarjeta').val(valTarjeta);
  }); 

  /**
   * Botones para documentos de baja
   * Placas
   */
  $(document).on('click', '#has-placas-si, #has-placas-no', function(e){
    e.preventDefault();
    ele=$(this);
    iElementPlaca = ele.attr('id');
    if(iElementPlaca == 'has-placas-si'){
      clasPlaca = 'fondo-verde';
      $('#has-placas-no').removeClass('fondo-rojo');
      $('#biMpPlacas').attr('disabled', true);
      //$('#hasPlacas').attr('disabled', true);
      $('.handledByPlacas').hide('slow');
      valPlaca=1;
    }else if (iElementPlaca == 'has-placas-no'){
      clasPlaca = 'fondo-rojo';
      $('#has-placas-si').removeClass('fondo-verde');
      $('#biMpPlacas').attr('disabled', false);
      //$('#hasPlacas').attr('disabled', false);
      $('.handledByPlacas').show('slow');
      valPlaca=0;
    }
    neu_clas = $('#'+iElementPlaca).addClass(clasPlaca);
    $('#hasPlacas').val(valPlaca);
  });

  /**
   * Botones para documentos de baja
   * documento de baja
   */
  $(document).on('click', '#docu-baja-si, #docu-baja-no', function(e){
    e.preventDefault();
    ele=$(this);
    iElementMain = ele.attr('id');
    if(iElementMain == 'docu-baja-si'){
      clasMain = 'fondo-verde';
      $('#docu-baja-no').removeClass('fondo-rojo');
      $('.handledByDocu').show('slow');
      $('.handledByDetallesDocu').hide('slow');
      $('#biCompBaja').attr('disabled', false);
      $('#idMarcaFinanzas').attr('disabled', true);
            //
            $('#biMpPlacas').attr('disabled', true);
            $('#biTarjetaC').attr('disabled', true);
            $('#biMpTarjeta').attr('disabled', true);
            $('#biCompBaja').attr('disabled', false);
            $('#hasPlacas').attr('disabled', true);
            $('#hasTarjeta').attr('disabled', true);

      val=1;
    }else if (iElementMain == 'docu-baja-no'){
      clasMain = 'fondo-rojo';
      $('#biCompBaja').attr('disabled', true);
      $('#idMarcaFinanzas').attr('disabled', false);
      $('#docu-baja-si').removeClass('fondo-verde');
      $('.handledByDocu').hide('slow');
      $('.handledByDetallesDocu').show('slow');

        $('#hasPlacas').attr('disabled', false);
        $('#hasTarjeta').attr('disabled', false);
      val=0;

    }
    neu_clas = $('#'+iElementMain).addClass(clasMain);
    $('#hasBaja').val(val);
  });

  /**
   * Para campos de importación
   */
  $('#txProcedencia').on('change', function(e){
    v = $(this).val();
    if(v == 'IMPORTADO'){
      $('#div-pedimento').show('slow');
      $('#id_cat_pedimento').attr('disabled', false);
      $('#fhPedimento').attr('disabled', false);
      $('#txFolioPedimento').attr('disabled', false);
      $('#biPedimento').attr('disabled', false);
    }else{
      $('#div-pedimento').hide('slow');
      $('#id_cat_pedimento').attr('disabled', true);
      $('#fhPedimento').attr('disabled', true);
      $('#txFolioPedimento').attr('disabled', true);
      $('#biPedimento').attr('disabled', true);
    }
  });

  /**
   * Campos de archivo de "quién recoge aditamentos"
   */
  $('.select-file').on('change', function(e){
    v = $(this).val();
    q = $(this).attr('id');
    n = '#l-'+q;
    nv = v===''?'Seleccionar archivo':document.getElementById(q).files.item(0).name
    $(n).text(nv);
  });

  /**
   * Eliminar archivos de solicitud
   * enviar data
   */
  $('.delete-file-sol').on('click', function(e){
    if(confirm('¿Deseas eliminar el archivo?')){
      ia = $(this).attr('drv');
      fs = $(this).attr('tst');
      dataSend = {
        "_token": token.content,
        "ia": parseInt(ia)
      };
      $.ajax({
        url: ubase + '/tramite/elimina-archivo',
        dataType: 'json',
        contentType: 'application/json',
        type: 'POST',
        data: JSON.stringify(dataSend),
        headers: {
          'X-CSRF-TOKEN': token.content
        },
        success: function(data) {
          if(data.quedan === 0 ){
            controls=fs.split('|');
            for(c=0;c<controls.length;c++){
              $('#'+controls[c]).attr('required',true);
            }
          }
          $('.block-'+ia).hide('slow').remove();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          crearMensaje(true,"Error","No pudimos procesar la solicitud <br>Código de error: " + jqXHR.status + " " + textStatus);
        }
      }); 
    }
  });

  /**
   * Recorrer el formulario al elemento en entrega de placas
   */
  if($('#scroll-marker').length > 0){
    if($('#scroll-marker').attr('target')!==''){
      target=$('#scroll-marker').attr('target');
      $('html, body').animate({
        scrollTop: $("#"+target).offset().top
      }, 250);
    }
  }

  /**
   * Esconder botón de expediente válidos si cambian docs tercero (entrega)
   */
  $('.force-val').on('click', function(e){
    if($('#confirma-entrega').length > 0){
      $('#confirma-entrega').hide('slow');
    } 
    
  });

  /**
   * Informe
   */
    // window.addEventListener("DOMContentLoaded",function(){
    //     document.getElementsByClassName("fondo_transparente")[0].style.display="block";
    //     return false
    // });
    // document.getElementsByClassName("modal_cerrar")[0].addEventListener("click",function(){
    //     document.getElementsByClassName("fondo_transparente")[0].style.display="none" 
    // });

});

// Validacion de formularios
(function() {
  'use strict';
  window.addEventListener('load', function() {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function(form) {
      form.addEventListener('submit', function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === true) {
          $('#modal-zagruzka').modal('show');
          $('#btn-send').attr('disabled', true);
          form.submit();
        }else{
          //console.log($( this ).find( ":invalid" ));
          crearMensaje(true,"Error","Por favor completa los campos marcados con rojo. Asegúrate también de haber adjuntado los archivos solicitados.");
        }
        form.classList.add('was-validated');
      }, false);
    });
  }, false);
})();
